import React from "react";
import { Layout } from "../../../components/Layout";
import { CategorySidebar } from "../../../components/sidebars/CategorySidebar";
import { GET_CATEGORY_BY_SLUG, } from "../../../mysql/queries/categories";
import { GET_BASE_INDEX } from "../../../mysql/queries/index-page";
import { Meta } from "../../../components/Meta";
import { GET_ALL_POSTS_BY_CATEGORY } from "../../../mysql/queries/posts";
import { getPosts } from "../../../util/Post";
import { BlogCategoryContent } from "../../../components/BlogCategoryContent";

export const getStaticProps = async ({ params }) => {
  const category = await GET_CATEGORY_BY_SLUG('blog');
  const page = Number(1);

  const filePosts = getPosts().map((post) => ({
    ...post,
    post_date: post.date,
    uri: post.slug,
    post_content: post.contentHTML,
    categories: [
      {
        "uri": "/category/blog/",
        "name": "Blog"
      }]
  }));
  const dbPosts = await GET_ALL_POSTS_BY_CATEGORY(
    "blog",
  );

  const posts = [...filePosts, ...dbPosts];
  const indexData = await GET_BASE_INDEX();

  return {
    props: {
      data: {
        currentPage: page,
        category: {
          ...category,
          posts
        },
        ...indexData,
      },
    },
  };
};

const BlogCategoryPage = ({ data }) => {
  const title = "Category: " + data?.category?.name + " | Radcade";
  const description = data?.category?.name + "...";
  const url = `${data.settings[0].siteurl}/category/${data.category.slug}/`;

  return (
    <Layout data={data}>
      <Meta title={title} description={description} url={url} />
      <div className="responsive flex-col md:flex-row">
        <div className="flex-grow">
          <BlogCategoryContent data={data} />
        </div>
        <div className="w-sidebar flex-shrink-0 md:ml-5">
          <CategorySidebar data={data} />
        </div>
      </div>
    </Layout>
  );
};

export default BlogCategoryPage;
